import Links from './Links'
export default Links
